export default {"src":"/_next/static/media/home-bg-mobile.90f4a2a9.svg","height":533,"width":430,"blurWidth":0,"blurHeight":0};